'use strict';

require('normalize.css/normalize.css');

require('./index.less');


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/style/index.js
// module id = 119
// module chunks = 6